<!--高级模板-模板使用人填写变量并发起合同-->
<template>
  <!--填写合同-->
  <el-container class="to-create">
    <!--    第一步-->
    <template v-if="step === 'step1'">
      <!--左侧-->
      <el-aside
        width="2.80rem"
        class="aside-left"
        :style="{ height: boxHeight }"
      >
        <p class="page-total">
          共{{ contractInfo.items }}页
          <a
            href="javascript: void(0)"
            @click="
              apiMethods.FileOperController.download_down({
                targetId: contractInfo.contractId,
                fileType: fileType,
                sign: contractInfo.sign,
                ts: contractInfo.ts,
                fix: '.pdf'
              })
            "
            class="fr color-success cred"
            >下载</a
          >
        </p>
        <div class="page-con">
          <template v-for="i in contractInfo.items">
            <div
              @click="getContractDetailByNum(i)"
              :key="i"
              :class="currentInfo.page === i ? 'active' : ''"
              class="list"
            >
              <img v-if="contractList[i]" :src="contractList[i].url" />
              <img v-else src="/images/contr_default.jpg" alt="" />
              <span>{{ i }}</span>
            </div>
          </template>
        </div>
        <div class="go-Page">
          <div>
            <div>
              <div class="bd">
                <el-input
                  v-model="goPageNum"
                  placeholder="输入页码"
                  type="number"
                  @keyup.enter.native="handleContractPageClick"
                />
                /{{ contractInfo.items }}
              </div>
              <a @click="handleContractPageClick">GO</a>
            </div>
          </div>
        </div>
      </el-aside>
      <!--合同显示详情-->
      <el-main class="main-content" :style="{ height: boxHeight }">
        <contract-view
          ref="contractView"
          :chapteFixed="chapteFixed"
          :contract-info.sync="currentInfo"
          :page="currentInfo.page"
          :items="contractInfo.items"
          :scaleValue.sync="scaleValue"
          :chapter-list.sync="chapteList"
          @pre-page="getContractDetailByNum($event)"
          @next-page="getContractDetailByNum($event)"
          @toCurrentPage="toCurrentPage"
        />
        <!--添加附件-->
        <div ref="accessory" class="text-center accessory-box">
          <!-- 去顶部去底部按钮-->
          <template
            v-if="contractInfo && contractInfo.items && contractInfo.items > 1"
          >
            <span class="jumpFirst" @click="goPageAndFixed(1)"
              ><img src="../../assets/images/btn-down.png"
            /></span>
            <span class="jumpLast" @click="goPageAndFixed(contractInfo.items)"
              ><img src="../../assets/images/btn-down.png"
            /></span>
          </template>
          <div
            @click="accessoryShow = !accessoryShow"
            class="text-center btn"
            ref="step4"
          >
            <i class="el-icon-circle-plus"></i>
            附属材料<i
              v-if="accessoryShow"
              class="el-icon-arrow-down arrow"
            ></i>
            <i v-else class="el-icon-arrow-up arrow"></i>
          </div>
          <ul class="text-left accessory-list" id="accessoryList">
            <span
              style="position: absolute;top:10px;left:15px;color:rgba(0,0,0,0.65);font-size: 12px;"
              ><img
                style="width: 8px;height:8px;margin-right:3px;vertical-align: middle;"
                src="../../assets/images/x-icon.png"
              />仅供参与方查阅，不用于签署</span
            >
            <li class="accessory-group">
              <template v-if="attatchFileNamesJson.length">
                <p
                  v-for="(item, i) in attatchFileNamesJson"
                  class="list-item"
                  :key="i"
                >
                  <span>{{ item.fileName }}</span>
                  <i
                    v-if="!item.isTplFile"
                    @click="delAttatchFileNamesJson(item, i)"
                    class="el-icon-error del"
                  ></i>
                </p>
              </template>
<!--              <div-->
<!--                class="title upload-accessory"-->
<!--                v-if="attatchFileNamesJson.length < 3"-->
<!--              >-->
<!--                <div class="div-upload">+</div>-->
<!--                <input-->
<!--                  class="input-upload"-->
<!--                  @change="handleAttatchFileUpload"-->
<!--                  type="file"-->
<!--                  name="attatchInput"-->
<!--                />-->
<!--              </div>-->
            </li>
          </ul>
        </div>
      </el-main>
      <!--右侧-->
      <el-aside
        width="2.80rem"
        class="aside-right"
        :style="{ height: boxHeight }"
      >
        <div class="top">
          <h1 class="t-title">填写模板变量</h1>
          <div class="box">
            <el-form
              class="variablesForm"
              label-width="40px"
              :model="getWidgets"
              ref="varForm"
            >
              <template v-if="getWidgets && getWidgets.chapteList.length">
                <template v-for="(item, index) in getWidgets.chapteList">
                  <template v-if="item.varType < flagType.flag.SIGNNATURE">
                    <p class="var-name-sty" :key="index">{{showName(item) ? item.varName : item.inputId}}</p>
                    <!--        多行文本-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType === flagType.flag.MULTITEXT"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入文本',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        }
                      ]"
                    >
                      <el-input
                        :class="{ outstanding: !!item.selected }"
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        type="textarea"
                        resize="none"
                        :rows="4"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        :maxlength="item.fontMaxNum"
                        v-model="item.value"
                      />
                    </el-form-item>

                    <!--        文本-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.TEXT"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入文本',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        数字-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.NUMBER"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入数字',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.number,
                          message: '请输入数值',
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        日期-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.DATE"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请选择日期',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.regex,
                          regex: /^(\d{4}-\d{2}-\d{2})?$/,
                          message: '请选择正确的日期',
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-date-picker
                        value-format="yyyy-MM-dd"
                        align="left"
                        @click.native="focusWidget(item)"
                        @change="chapValChange($event,item)"
                        :class="{ outstanding: !!item.selected }"
                        v-model="item.value"
                        type="date"
                        :editable="false"
                        :clearable="!item.varIsMust"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                      />
                    </el-form-item>

                    <!--        手机号码-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.PHONE"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入手机号码',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.mobile,
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        身份证号码-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.IDCARD"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入中国大陆18位身份证号码',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.idCard,
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        营业执照号-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.LICENCENO"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入营业执照号',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.businessLicenseVal,
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        统一社会信用代码-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.SOCIALCODE"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入统一社会信用代码',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.businessLicenseVal,
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>

                    <!--        电子邮箱-->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="index"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.EMAIL"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请输入电子邮箱',
                          trigger: 'change'
                        },
                        {
                          validator: $validator.maxLength,
                          maxLength: item.fontMaxNum,
                          trigger: 'change'
                        },
                        {
                          validator: $validator.email,
                          trigger: 'change',
                          emptyAble: true
                        }
                      ]"
                    >
                      <el-input
                        v-model="item.value"
                        :class="{ outstanding: !!item.selected }"
                        :placeholder="
                          item.varName ||
                            flagType.getFlagOption(item.varType).title
                        "
                        @click.native="focusWidget(item)"
                        @input="chapValChange($event,item)"
                        :maxlength="item.fontMaxNum"
                      />
                    </el-form-item>
                    <!-- 单选 -->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="`chap-${index}`"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.RADIO"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请选择选项',
                          trigger: 'change'
                        }
                      ]"
                    >
                      <el-radio-group v-model="item.value" @change="chapValChange($event,item)">
                        <p v-for="(vv,i) of item.defineValue" :key="i">
                          <el-radio :label="vv.val" >{{vv.val}}</el-radio>
                        </p>
                      </el-radio-group>
                    </el-form-item>
                    <!-- 多选 -->
                    <el-form-item
                      :label="index + 1 + ''"
                      :key="`chap-${index}`"
                      :prop="'chapteList.' + index + '.value'"
                      v-if="item.varType == flagType.flag.MULTIPLE"
                      :rules="[
                        {
                          required: item.varIsMust,
                          message: '请选择选项',
                          trigger: 'change'
                        }
                      ]"
                    >
                      <el-checkbox-group v-model="item.value" @change="chapValChange($event,item)">
                        <p v-for="(vv,i) of item.defineValue" :key="i+ new Date()">
                          <el-checkbox :label="vv.val">{{vv.val}}</el-checkbox>
                        </p>
                      </el-checkbox-group>
                    </el-form-item>
                  </template>
                </template>
              </template>
            </el-form>
          </div>
        </div>
      </el-aside>
    </template>
    <!--    第二步-->
    <template v-if="step === 'step2'">
      <el-form
        size="small"
        ref="contForm"
        :model="contractInfo"
        class="cont-form"
      >
        <div class="f-top">
          <el-form-item>
            <h4><i></i>合同名称</h4>
          </el-form-item>
          <el-form-item
            prop="contractName"
            :rules="myRules.tplName"
            class="s-er"
          >
            <el-row style="width: 550px;">
              <el-input
                v-model="contractInfo.contractName"
                placeholder="请输入合同名称"
              />
            </el-row>
          </el-form-item>
        </div>

        <div class="f-center">
          <el-form-item>
            <div class="h4"><i></i>签署设置</div>
          </el-form-item>
          <el-form-item>
            <div class="tab">
              <div
                v-if="signatoryJson && signatoryJson.length"
                class="list-box"
              >
                <template v-for="(item, i) in signatoryJson">
                  <el-form
                    :model="item"
                    size="small"
                    ref="contractListTab"
                    :key="i"
                    :data-signOwner="item.signOwner"
                    class="contract-lit__tab"
                  >
                    <!--固定签署方-->
                    <div class="t-row" v-if="item.fix == 1">
                      <span class="index" v-if="contractInfo.ifOrder">{{
                        i + 1
                      }}</span>
                      <div class="ov" style="width: 106px;margin-left: 15px;">
                        {{ item.signOwner }}
                      </div>
                      <div class="ov" style="width: 80px;">固定人员：</div>
                      <div class="ov" style="width: 220px;margin-right: 25px;">
                        {{ item.emailOrPhone }}
                      </div>
                      <div class="ov" style="width: 240px;margin-right: 25px;">
                        {{ item.signatoryFullName }}
                      </div>
                      <div class="ov" style="width: 70px;margin-right: 25px;">
                        {{ +item.signatoryUserType === 0 ? "个人" : "企业" }}
                      </div>
                      <div class="ov" style="width: 185px;margin-right: 20px;">
                        {{ item.signatoryIdentityCard }}
                      </div>
                      <div class="ov fb">
                        <i class="icon-gg" v-if="+item.authLevel === 11"></i>
                        <i class="icon-nogg" v-else></i>
                        需要人脸识别
                        <el-tooltip
                          effect="light"
                          content=""
                          placement="bottom-end"
                        >
                          <div slot="content">
                            选择人脸识别，可把签署方的<br />人脸视频文件作为签署证据
                          </div>
                          <i
                            class="el-icon-question"
                            style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>

                    <!--指定签署方-->
                    <div class="t-row" v-else>
                      <span class="index" v-if="contractInfo.ifOrder">{{
                        i + 1
                      }}</span>
                      <div
                        class="user-type"
                        style="width: 106px;margin-left: 15px;"
                      >
                        {{ item.signOwner }}
                      </div>
                      <div style="width: 80px;">指定人员：</div>
                      <div class="col" style="width: 220px;margin-right: 25px;">
                        <el-form-item
                          prop="emailOrPhone"
                          :rules="rulesTab.emailOrPhone"
                        >
                          <el-input
                            @blur="
                              () => {
                                (item.emailOrPhone = $utils.trim(
                                  item.emailOrPhone
                                )),
                                  getUserInfoBySelectTargetId(
                                    item.emailOrPhone,
                                    i
                                  );
                              }
                            "
                            v-model="item.emailOrPhone"
                            placeholder="签署方接收手机/邮箱"
                          >
                            <i
                              class="icon icon-btn_tels"
                              style="background-size: contain;cursor: pointer"
                              slot="suffix"
                              @click="handleTelsClickOther(item, i)"
                            ></i>
                          </el-input>
                        </el-form-item>
                      </div>

                      <div class="col" style="width: 240px;margin-right: 25px;">
                        <!-- 下拉选择框 -->
                        <template
                          v-if="
                            item.canSelectArray &&
                              ((+item.signatoryUserType === 1 &&
                                item.canSelectArray.length > 0 &&
                                !item.ManualInput) ||
                                (+item.signatoryUserType === 0 &&
                                  item.canSelectArray.length > 1))
                          "
                        >
                          <el-form-item>
                            <el-select
                              @change="handleSelectCorpAccount($event, item)"
                              v-model="item.canSelectArrayIndex"
                              size="small"
                              class="select"
                              style="width: 100%"
                            >
                              <el-option
                                v-for="(v, vi) in item.canSelectArray"
                                :key="vi"
                                :value="vi"
                                :label="v.name"
                              />
                              <!--手动输入，选择此项显示输入框，手动输入-->
                              <el-option
                                v-if="item.signatoryUserType === 1"
                                value="ManualInput"
                                label="手动输入"
                              />
                            </el-select>
                          </el-form-item>
                        </template>
                        <template v-else>
                          <el-form-item
                            prop="signatoryFullName"
                            :rules="rulesTab.signatoryFullName"
                            :show-message="item.disabled !== 'disabled'"
                          >
                            <el-input
                              :value="item.signatoryFullName"
                              @input="
                                val => {
                                  item.signatoryFullName = val;
                                }
                              "
                              :disabled="item.disabled === 'disabled'"
                              placeholder="请输入签署方名称"
                            />
                          </el-form-item>
                        </template>
                      </div>
                      <div class="col" style="width: 70px;margin-right: 25px;">
                        <el-form-item>
                          <el-select
                            @change="handleSignUserType(item)"
                            v-model="item.signatoryUserType"
                            :disabled="item.disabled === 'disabled'"
                            size="small"
                            class="select"
                          >
                            <el-option :value="0" label="个人" />
                            <el-option :value="1" label="企业" />
                          </el-select>
                        </el-form-item>
                      </div>

                      <!-- 身份证 和 营业执照号 -->
                      <div
                        v-if="item.signatoryUserType === 0"
                        class="col"
                        style="width: 185px;margin-right: 20px;"
                      >
                        <!-- 身份证 -->
                        <el-form-item
                          v-if="item.signatoryUserType === 0"
                          prop="IDCard"
                          :rules="
                            item.disabled !== 'disabled' ? rulesTab.IDCard : {}
                          "
                          :show-message="item.disabled !== 'disabled'"
                          style="position: relative;"
                        >
                          <el-input
                            v-model="item.IDCard"
                            :disabled="item.disabled === 'disabled'"
                            :class="{
                              'no-padding': item.disabled ? true : false
                            }"
                            placeholder="请输入中国大陆18位身份证号码"
                          />
                          <a
                            @click="handleTargetIdChange(item)"
                            v-if="item.ischange === 1"
                            href="javascript:void (0)"
                            class="color-success amend-signator amend-tab__form"
                            >修改</a
                          >
                        </el-form-item>
                      </div>
                      <div class="fb">
                        <!--模板勾选了人脸，这里不可更改-->
                        <!--<template v-if="+item.authLevel===11 && !item.checkedAuthLevel">-->
                        <!--<i class="icon-gg"></i>-->
                        <!--需要人脸识别-->
                        <!--<el-tooltip effect="light" content="" placement="bottom-end">-->
                        <!--<div slot="content">选择人脸识别，可把签署方的<br/>人脸视频文件作为签署证据</div>-->
                        <!--<i class="el-icon-question"-->
                        <!--style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer"></i>-->
                        <!--</el-tooltip>-->
                        <!--</template>-->

                        <!--<el-form-item v-else>-->
                        <!--<el-checkbox v-model="item.authLevel" :true-label="11" style="margin: 0;"-->
                        <!--:false-label="null"-->
                        <!--@change="authLevelChange(item,i)">-->
                        <!--需要人脸识别-->
                        <!--</el-checkbox>-->
                        <!--<el-tooltip effect="light" content="" placement="bottom-end">-->
                        <!--<div slot="content">选择人脸识别，可把签署方的<br/>人脸视频文件作为签署证据</div>-->
                        <!--<i class="el-icon-question"-->
                        <!--style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer"></i>-->
                        <!--</el-tooltip>-->
                        <!--</el-form-item>-->

                        <!--禁用人脸勾选-->
                        <i class="icon-gg" v-if="+item.authLevel === 11"></i>
                        <i class="icon-nogg" v-else></i>
                        需要人脸识别
                        <el-tooltip
                          effect="light"
                          content=""
                          placement="bottom-end"
                        >
                          <div slot="content">
                            选择人脸识别，可把签署方的<br />人脸视频文件作为签署证据
                          </div>
                          <i
                            class="el-icon-question"
                            style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer"
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </el-form>
                </template>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 集团账户设置了审批流 -->
        <div
          class="f-center2"
          v-if="isGroup && checkedBatch === false && hasApplyApproval === true"
        >
          <el-form-item>
            <h4 style="display: inline-block;margin-right: 15px;">
              <i></i>选择审批流程
            </h4>
            <div class="bow">
              <el-select
                v-model="approvalFlowSelect"
                size="mini"
                placeholder="请选择审批流程"
                @change="handleChangeApprovalFlow"
              >
                <el-option
                  v-for="(v, index) in approvalFlowList"
                  :key="index"
                  :value="v.flowId"
                  :label="v.flowName"
                ></el-option>
              </el-select>
              <div
                v-if="flows.length > 0"
                style="border:1px solid rgba(229,229,229,1);border-radius:4px;margin-top: 12px;"
              >
                <div style="display: inline-block;position: relative;">
                  <flow
                    v-for="(v, index) in flows"
                    :model="v"
                    :hiddenArrow="v.hiddenArrow"
                    :hiddenRemove="false"
                    :key="index"
                  >
                    <div slot="username">
                      <span style="color: #aaaaaa;">{{ v.partyName }}</span>
                    </div>
                  </flow>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 抄送设置 -->
        <div class="f-center2" v-if="isGroup && checkedBatch === false">
          <el-form-item v-if="isGroup && checkedBatch === false">
            <h4><i></i>设置抄送人</h4>
          </el-form-item>
          <el-form-item v-if="isGroup && checkedBatch === false" class="bow">
            <div
              style="border:1px solid rgba(229,229,229,1);border-radius:4px;overflow: hidden;padding: 8px 0;"
            >
              <div class="audit-flex">
                <div
                  v-for="(item, index) in arrayCopior"
                  :key="index"
                  class="audit-box"
                >
                  <i class="icon icon-audit-touxiang66"></i>
                  <!-- <i class="icon icon-audit-touxiang66dark"></i> -->
                  <div class="auditor">
                    {{ item.userName || item.partyName }}
                  </div>
                  <i
                    v-show="!item.hideRemove"
                    @click="handleClickRemoveArrayCopior(index)"
                    class="icon icon-audit-cuowu17 size17"
                  ></i>
                </div>
                <!-- 添加按钮 -->
                <div
                  class="audit-add"
                  @click="clickHandleAddAuditorOrCopyer(false)"
                >
                  <i
                    class="icon icon-audit-add-2x"
                    style="width: 78px;height: 78px;"
                  ></i>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>

        <!--  -->
        <!-- <div class="f-bottom" v-if="!isGroup"> -->
        <!-- 签署消费方式改版 2019-2-14 15:51:25 -->
        <!-- <el-form-item>
            <h4><i></i>支付方式</h4>
          </el-form-item> -->
        <!-- 自定义select 重构 -->
        <!-- <el-form-item class="bow">
            <el-select v-model="contractInfo.consumMode" placeholder="请选择">
              <el-option label="发起方支付全部费用" :value="0"></el-option>
              <el-option label="各方各自支付自己的费用" :value="1"></el-option>
            </el-select>
            原来就隐藏的 -->
        <!--              <el-popover-->
        <!--                placement="bottom-start"-->
        <!--                :offset="15"-->
        <!--                v-model="visibleChangeSelectStatus"-->
        <!--                trigger="click">-->
        <!--                <ul>-->
        <!--                  <li style="padding: 10px 15px">-->
        <!--                    <el-radio @change="visibleChangeSelect" v-model="contractInfo.consumMode"-->
        <!--                              :label="0" border class="radio">发起方支付全部费用-->
        <!--                    </el-radio>-->
        <!--                  </li>-->
        <!--                  <li style="padding: 0px 15px 10px 15px">-->
        <!--                    <el-radio @change="visibleChangeSelect" v-model="contractInfo.consumMode" :label="1"-->
        <!--                              border class="radio">各方各自支付自己的费用-->
        <!--                    </el-radio>-->
        <!--                  </li>-->
        <!--                </ul>-->
        <!--                <el-button slot="reference" style="width: 450px;background: rgb(248,248,248);padding: 0;" class="pay-type">-->
        <!--                  <div style="width: 450px;z-index: 10;">-->
        <!--                    <template v-if="contractInfo.consumMode === 0">-->
        <!--                      <label class="el-radio radio el-radio&#45;&#45;small is-checked">-->
        <!--											<span class="el-radio__input is-checked">-->
        <!--												<span class="el-radio__inner"></span>-->
        <!--											</span>-->
        <!--                        <span class="el-radio__label">发起方支付全部费用</span>-->
        <!--                        <i :class="{'el-icon-arrow-down': true, 'custom-transform-rotateZ-180': visibleChangeSelectStatus, 'custom-transform-rotateZ-0': !visibleChangeSelectStatus}"-->
        <!--                           style="vertical-align: text-top;font-size: 20px;color: #cccccc;margin-left: 10px;"></i>-->
        <!--                      </label>-->
        <!--                    </template>-->
        <!--                    <template v-else>-->
        <!--                      <label role="radio" aria-checked="true" tabindex="0" class="el-radio radio el-radio&#45;&#45;small is-checked">-->
        <!--											<span class="el-radio__input is-checked">-->
        <!--												<span class="el-radio__inner"></span>-->
        <!--											</span>-->
        <!--                        <span class="el-radio__label">各方各自支付自己的费用</span>-->
        <!--                        <i :class="{'el-icon-arrow-down': true, 'custom-transform-rotateZ-180': visibleChangeSelectStatus, 'custom-transform-rotateZ-0': !visibleChangeSelectStatus}"-->
        <!--                           style="vertical-align: text-top;font-size: 20px;color: #cccccc;margin-left: 10px;"></i>-->
        <!--                      </label>-->
        <!--                    </template>-->

        <!--                  </div>-->
        <!--                </el-button>-->
        <!--              </el-popover>-->
        <!-- 原来就隐藏的 end
          </el-form-item>
        </div> -->

        <el-form-item class="text-center">
          <el-button class="f-btn nobg-btn" @click="preStep">上一步</el-button>
          <el-button class="f-btn" @click="publishTpl" type="danger"
            >立即发起</el-button
          >
        </el-form-item>
      </el-form>
    </template>

    <!--通讯簿列表-->
    <el-dialog
      title="选择签署方"
      :visible.sync="showTel"
      lock-scroll
      width="749px"
    >
      <!-- tabs -->
      <el-tabs v-model="activeTabSigner">
        <!-- 我的通讯录 -->
        <el-tab-pane label="常用签署方" name="default">
          <el-row class="tel-search">
            <el-col :span="6">
              <el-input
                v-model="telPageInfo.accountNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="邮箱/手机号"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.name"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="签署方姓名"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.idNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="证件号"
              />
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button @click="getTelList" size="small" class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div
            class="tel-box"
            style="max-height: 340px;overflow: auto; min-width: 749px"
          >
            <el-table
              @row-click="handleTelRowClickSelectRow"
              :data="telList"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="签署方名称" prop="enterpriseName" />
              <el-table-column label="证件号" prop="businessLicense" />
              <el-table-column label="邮箱/手机号" prop="mobileOrChild" />
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="telPageInfo.itemPage"
            :page-sizes="[6, 12, 30, 60]"
            :page-size="telPageInfo.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="telPageInfo.total"
            style="text-align: right;margin-top: 10px"
          />
        </el-tab-pane>
        <!-- 我的组织 -->
        <el-tab-pane
          v-if="isGroup"
          :label="activeTabOrganizationName"
          name="organization"
        >
          <el-row class="tel-search">
            <el-col :span="18">
              <el-col :span="8" style="padding: 0 10px">
                <el-input
                  clearable
                  v-model="myCorpModel.keyword"
                  @keyup.enter.native="clickHandleMyCorpSearch()"
                  size="small"
                  placeholder="邮箱/手机号"
                />
              </el-col>
              <el-col :span="8" style="padding: 0 10px">
                <el-input
                  clearable
                  v-model="myCorpModel.corpUserName"
                  size="small"
                  placeholder="签署方名称"
                ></el-input>
              </el-col>
              <el-col :span="8" style="padding: 0 10px">
                <el-select
                  v-model="myCorpModel.corpGroupId"
                  placeholder="请选择部门"
                  size="small"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(item, i) in department"
                    :key="i"
                    :label="item.groupName"
                    :value="item.corpGroupId"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-button
                @click="clickHandleMyCorpSearch()"
                size="small"
                class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div class="tel-box" style="height: 415px;overflow: auto;">
            <el-table
              v-loading="myCorpModel.loading"
              :empty-text="myCorpModel.emptyText"
              @row-click="handleRowClickMyCorp"
              :data="tableListMyCorp"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="邮箱/手机号" prop="targetId" />
              <el-table-column label="签署方名称" prop="userName" />
              <el-table-column label="部门" prop="groupNames" />
            </el-table>
          </div>
          <br />
          <el-pagination
            @size-change="handleSizeChangeQueryToolMyCorp"
            @current-change="handleCurrentChangeQueryToolMyCorp"
            :current-page="myCorpModel.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="myCorpModel.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="myCorpModel.total"
            style="text-align: right;"
          />
        </el-tab-pane>
      </el-tabs>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="handleClickSelectSignorOk()"
          type="danger"
          size="small"
          class="btn"
          >确定</el-button
        >
      </p>
    </el-dialog>

    <!--审批人/抄送人-->
    <el-dialog
      :title="auditAndCopyTitle"
      :visible.sync="visibleAuditAndCopy"
      width="50%"
    >
      <el-row class="tel-search">
        <el-col :span="18">
          <el-col :span="8" style="padding: 0 10px">
            <el-input
              clearable
              v-model="auditAndCopyModel.keyword"
              @keyup.enter.native="clickHandleAuditorOrCopyerSearch()"
              size="small"
              placeholder="邮箱/手机号"
            />
          </el-col>
          <el-col :span="8" style="padding: 0 10px">
            <el-input
              clearable
              v-model="auditAndCopyModel.corpUserName"
              size="small"
              placeholder="签署方名称"
            />
          </el-col>
          <el-col :span="8" style="padding: 0 10px">
            <el-select
              v-model="auditAndCopyModel.corpGroupId"
              placeholder="请选择部门"
              size="small"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(item, i) in department"
                :key="i"
                :label="item.groupName"
                :value="item.corpGroupId"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-button
            @click="clickHandleAuditorOrCopyerSearch()"
            size="small"
            class="btn"
            >查询</el-button
          >
        </el-col>
      </el-row>

      <div class="tel-box" style="height: 415px;overflow: auto;">
        <el-table
          v-loading="auditAndCopyModel.loading"
          :empty-text="auditAndCopyModel.emptyText"
          @row-click="handleRowClickAuditAndCopy"
          :data="tableListAuditAndCopy"
          style="width: 100%"
          highlight-current-row
          tooltip-effect="dark"
          stripe
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{
            background: '#f9f9f9',
            color: '#333333',
            fontWeight: '500'
          }"
        >
          <el-table-column label="签署方名称" prop="userName" />
          <el-table-column label="邮箱/手机号" prop="targetId" />
          <el-table-column label="部门" prop="groupNames" />
        </el-table>
      </div>
      <br />
      <el-pagination
        @size-change="handleSizeChangeQueryToolAuditAndCopy"
        @current-change="handleCurrentChangeQueryToolAuditAndCopy"
        :current-page="auditAndCopyModel.itemPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="auditAndCopyModel.pageSize"
        layout="sizes, prev, pager, next, jumper, total"
        :total="auditAndCopyModel.total"
        style="text-align: right;"
      />

      <p slot="footer" class="dialog-footer">
        <el-button @click="visibleAuditAndCopy = false" size="small" class="btn"
          >取消</el-button
        >
        <el-button
          @click="clickHandleAddAuditorOrCopyerSubmit()"
          type="danger"
          size="small"
          class="btn"
          >添加</el-button
        >
      </p>
    </el-dialog>

    <!--1.填写企业证件号，2.对填写的姓名身份证号进行二要素验证错误-->
    <sign-info-tips-dialog
      :show.sync="visibleCredit"
      :entCreditArr="entCreditArr"
      :entCreditJson="entCreditJson"
      :userIdentityInfoArr="userIdentityInfoArr"
      @continue="addContractById"
      @cancel="handleDelSendContract"
    />

    <!--消费弹窗-->
    <el-dialog
      :visible.sync="priseVisibleDialog"
      @closed="handleDelSendContract"
      title="温馨提示"
      :show-close="false"
      width="400px"
      class="prise-dialog"
    >
      <div
        class="box-dashed text-center"
        style="margin-top: 10px;padding-bottom: 5px"
      >
        <img src="/images/icon_signed.png" style="height: 80px" />
        <template v-if="priseInfo.mealInfo">
          <h4>
            本次共花费：
            <span class="color-danger">{{ priseInfo.mealInfo }}</span>
          </h4>
          <h4 v-if="priseInfo.point">
            另需要支付<span class="color-danger"
              >{{ priseInfo.point }}积分</span
            >
          </h4>
        </template>
        <h4 v-else style="font-weight: bold">
          本次共花费：<span class="color-danger"
            >{{ priseInfo.point }}积分</span
          >
        </h4>
        <p style="text-align: start;margin-left: 8px">
          <i class="el-icon-info"></i>
          发起后，签署方将收到签署短信通知，该通知72小时有效，请尽快完成签署！
        </p>
      </div>
      <div slot="footer" class="text-center">
        <el-button
          @click="toPay(priseInfo.cashierUrl)"
          type="danger"
          size="small"
          class="footer-btn"
          :disabled="payDisabled"
          >确定
        </el-button>
      </div>
    </el-dialog>
    <!--通讯簿列表-->
    <el-dialog
      title="选择签署方"
      :visible.sync="showTel"
      lock-scroll
      width="749px"
    >
      <!-- tabs -->
      <el-tabs v-model="activeTabSigner">
        <!-- 我的通讯录 -->
        <el-tab-pane label="常用签署方" name="default">
          <el-row class="tel-search">
            <el-col :span="6">
              <el-input
                v-model="telPageInfo.accountNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="邮箱/手机号"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.name"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="签署方姓名"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.idNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="证件号"
              />
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button @click="getTelList" size="small" class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div
            class="tel-box"
            style="max-height: 340px;overflow: auto; min-width: 749px"
          >
            <el-table
              @row-click="handleTelRowClickSelectRow"
              :data="telList"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="签署方名称" prop="enterpriseName" />
              <el-table-column label="证件号" prop="businessLicense" />
              <el-table-column label="邮箱/手机号" prop="mobileOrChild" />
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="telPageInfo.itemPage"
            :page-sizes="[6, 12, 30, 60]"
            :page-size="telPageInfo.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="telPageInfo.total"
            style="text-align: right;margin-top: 10px"
          />
        </el-tab-pane>
        <!-- 我的组织 -->
        <el-tab-pane
          v-if="isGroup"
          :label="activeTabOrganizationName"
          name="organization"
        >
          <el-row class="tel-search">
            <el-col :span="18">
              <el-col :span="8" style="padding: 0 10px">
                <el-input
                  clearable
                  v-model="myCorpModel.keyword"
                  @keyup.enter.native="clickHandleMyCorpSearch()"
                  size="small"
                  placeholder="邮箱/手机号"
                />
              </el-col>
              <el-col :span="8" style="padding: 0 10px">
                <el-input
                  clearable
                  v-model="myCorpModel.corpUserName"
                  size="small"
                  placeholder="签署方名称"
                ></el-input>
              </el-col>
              <el-col :span="8" style="padding: 0 10px">
                <el-select
                  v-model="myCorpModel.corpGroupId"
                  placeholder="请选择部门"
                  size="small"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(item, i) in department"
                    :key="i"
                    :label="item.groupName"
                    :value="item.corpGroupId"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-button
                @click="clickHandleMyCorpSearch()"
                size="small"
                class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div class="tel-box" style="height: 415px;overflow: auto;">
            <el-table
              v-loading="myCorpModel.loading"
              :empty-text="myCorpModel.emptyText"
              @row-click="handleRowClickMyCorp"
              :data="tableListMyCorp"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="邮箱/手机号" prop="targetId" />
              <el-table-column label="签署方名称" prop="userName" />
              <el-table-column label="部门" prop="groupNames" />
            </el-table>
          </div>
          <br />
          <el-pagination
            @size-change="handleSizeChangeQueryToolMyCorp"
            @current-change="handleCurrentChangeQueryToolMyCorp"
            :current-page="myCorpModel.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="myCorpModel.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="myCorpModel.total"
            style="text-align: right;"
          />
        </el-tab-pane>
      </el-tabs>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="handleClickSelectSignorOk()"
          type="danger"
          size="small"
          class="btn"
          >确定</el-button
        >
      </p>
    </el-dialog>
  </el-container>
</template>

<script>
import Flow from "../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../components/singer-form";
import ToolTip from "../../components/tool-tip";
import ContractView from "../../components/advancedVersion/contractView";
import SignInfoTipsDialog from "../../components/contract/signInfoTipsDialog";
import {
  postCreateApply,
  postFindByEmailOrMphon,
  convertDetailToShow,
  postTelFindByPagedEnterpriseList,
  postFileTempUpload,
  postFileTempUpload2,
  getDraftInfoByApplyId,
  tempConvertToContract,
  ApiMethods,
  configUrl,
  queryCreditCodeByEntName,
  queryUserValidateByNameIDnum,
  getCorpDraftInfoByApplyId
} from "../../assets/js/http-serve/http-methods";
import {
  mobileOrEmail,
  identityNo,
  businessVal,
  personalName
} from "../../assets/js/lib/valid-methods";
import VideoSign from "../../assets/js/http-serve/video-sign";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import flagType from "../../components/advancedVersion/flagType";

export default {
  components: {
    ContractView,
    ToolTip,
    SingerForm,
    draggable,
    Flow,
    SignInfoTipsDialog
  },
  data() {
    return {
      step: "step1",
      apiMethods: ApiMethods,
      boxHeight: "1170px",
      goPageNum: null, // 前往多少页
      // ..............右侧组件相关...........
      flagType: flagType,
      // .............附件相关.............
      accessoryShow: false,
      timer: null,
      // 附件参数信息 参数为json 现场上传{targetId: '', targetFix: '', origiName: ''}或者修改草稿箱已有的{codeName: '', origiName: ''}
      attatchFileNamesJson: [],
      // .............合同相关.............
      // 是否是集团账户
      isGroup: false,
      // 合同信息
      contractInfo: {
        items: 0,
        ts: null,
        sign: null,
        docHash: null,
        contractId: null,
        contractName: "",
        ifOrder: false, // 顺序签
        returnURL:
          configUrl().junziqianWebOp + "/signInfo/signList?signStatus=2",

        signatoryJson: "[]",
        attatchFileNamesJson: "[]",
        consumMode: 0, // 付费方式

        // 暂不需要的变量
        needVideoSign: 0, // 是否使用视频签署 1=启用
        serverCa: 1, // 是否云证书
        needCa: 0, // 硬key证书
        overDate: "",
        applyId: null,
        needQifengSign: 1
      },
      myRules: {
        tplName: [
          { max: 100, message: "合同名称不能超过100个字符", trigger: "change" },
          { required: true, message: "请输入合同名称", trigger: "change" }
        ]
      },
      // 合同列表
      contractList: [],
      // 合同的签章列表 {offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}
      chapteList: [],
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      // 合同缩放比例
      scaleValue: 100,
      chapteFixed: true,

      // .............页面右侧部分变量.............

      // 第二步
      // 批量签署方 checkbox
      checkedBatch: false,
      // 发起审批新流程
      flows: [],
      hasApplyApproval: false,
      approvalFlowList: [],
      approvalFlowSelect: undefined,
      // 抄送
      // 添加审批人/抄送人Dialog
      visibleAuditAndCopy: false,
      auditAndCopyTitle: "",
      auditAndCopyActive: false,
      auditAndCopyModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", //名称
        corpGroupId: "" // 部门ID
      },
      tableListAuditAndCopy: [], // 审批人 抄送人列表
      arrayCopior: [], // 抄送人数组
      tableAuditAndCopySelectRow: undefined,

      // 签署方 tabs
      activeTabSigner: "default", // 我的通讯录 default , 我的组织 organization
      activeTabOrganizationName: "我的组织",
      // 我的组织 选择签署人
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", //名称
        corpGroupId: "" // 部门ID
      },
      department: [], // 部门列表
      tableListMyCorp: [],
      tableSignorSelectRow: undefined,
      tableSignorSelectRowTargetID: undefined,
      // 联系人相关通讯录
      telList: [],
      telPageInfo: {
        itemPage: 1,
        pageSize: 6,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      },
      showTel: false,
      // 签署设置
      rulesTab: {
        emailOrPhone: [{ validator: mobileOrEmail, trigger: "change" }],
        signatoryMobile: [{ validator: mobileOrEmail, trigger: "change" }],
        childUserName: [{ validator: mobileOrEmail, trigger: "change" }],
        signatoryFullName: [{ validator: personalName, trigger: "blur" }],
        // signatoryIdentityCard: [{validator: identityNo, trigger: 'blur'}]
        IDCard: [{ validator: identityNo, trigger: "blur" }],
        BusinessLicenseNo: [{ validator: businessVal, trigger: "blur" }]
      },
      selectIndex: 0,
      /**
       * 重构
       * 签字人列表参数
       * // 后端必须要的
       * signOwner: 甲乙方,
       * childUserName: 企业联系, 如果是集团账户 存 corpUser
       * signatoryMobile: 个人联系,
       * signatoryFullName: 签署方名称,
       * signatoryIdentityCard: 证件号,
       * signatoryUserType: 用户类型,
       * authLevel: 认证类型身份、三四要素,
       * handSign: 签章类型,
       * chapteJson: [{page: 0, chaptes[固定签章,章位置]}],
       *
       * // 前端辅助变量
       * emailOrPhone: '', 邮箱和电话
       * canSelectArray: [], 新增集团账户 数组
       * canSelectArrayIndex： 0, // 选择下标
       * ischange: 0/1是否修改,
       * notRegister: false/true签署方是否注册,
       * disabled: "disabled是否禁止填写",
       * openUserTab: false/true打开弹窗,
       * order: 排序,
       * isEncrypt: false/true是否加密(通过查询的加密)}
       */

      signatoryJson: [],

      // 签署方身份信息验证相关 start
      //..... 验证用户输入的企业是否存在 start.....
      entCreditJson: null,
      entCreditArr: [],
      entNameArr: [],
      visibleCredit: false,
      //..... 验证用户输入的企业是否存在 end.....
      userIdentityInfoArr: [], // 存放需要进行姓名身份证二要素的数组
      // 签署方身份信息验证相关 end

      // ..........支付相关 start..........
      payDisabled: false,
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      payInfoData: {}
      // ..........支付相关 end............
    };
  },
  created() {
    let v = this.$store.getters.currentAuthUser;
    if (v && v.corpUserId) {
      this.isGroup = true;
      this.activeTabOrganizationName = v.corpName;
      // 集团账户情况下，需判断当前账户所在部门是否设置了审批流
      this.hasApprovalFlow();
    }
  },
  mounted() {
    let { userType } = this.$route.query;
    this.boxHeight = document.body.clientHeight - 60 + "px";

    this.getTemplateDetailByID();

    this.getTelList();
    if (userType != 0) {
      // 个人账户不查询组织或者抄送人信息
      if (this.isGroup) {
        this.queryToolMyCorp();
        this.getDepartmentList();
      }
      this.queryToolAuditAndCopy();
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  watch: {
    "contractInfo.consumMode"(val) {
      if (val === 1) {
        this.contractInfo.serverCa = 1;
      }
    },
    accessoryShow(val) {
      clearInterval(this.timer);
      let fileHeight = document.getElementById("accessoryList").clientHeight;
      if (val) {
        let top = -fileHeight;
        this.timer = setInterval(() => {
          if (top === 0) {
            return clearInterval(this.timer);
          }
          top += 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      } else {
        let top = 0;
        this.timer = setInterval(() => {
          if (top === -fileHeight) {
            return clearInterval(this.timer);
          }
          top -= 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      }
    }
  },
  computed: {
    /**
     *  返回组件列表
     * */
    getWidgets() {
      return {
        chapteList: this.chapteList.filter(
          item => item.varType < this.flagType.flag.SIGNNATURE && !item.copy
        )
      };
    }
  },
  methods: {
    /** 兼容变量名称老数据 */
    showName(item){
      const reg = /[0-9A-Z]{32}/g;
      return reg.test(item.inputId)
    },
    // 输入变量change ,同步改变 复制变量
    chapValChange(val,item){
      const list = this.chapteList;
      list.forEach((chap,i) => {
        if(chap.inputId === item.inputId && chap.copy){
          const newChap= {...chap,value:item.value}
          this.$set(list,i,newChap)
        }
      });
    },
    // 点击左侧组件定位
    focusWidget(selectedItem) {
      this.chapteList &&
        this.chapteList.length &&
        this.chapteList.map(item => {
          if (item.cindex === selectedItem.cindex) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
      // 定位组件页面
      if (this.currentInfo.page !== selectedItem.page + 1) {
        this.getContractDetailByNum(selectedItem.page + 1);
        this.toCurrentPage(selectedItem.page + 1); // 同步定位左侧list中的页数
      }

      // 定位组件页面位置
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let imgBox = document.getElementById("contBox");
      if (imgBox) {
        let {
          width: contBoxW,
          height: contBoxH
        } = imgBox.getBoundingClientRect();
        let scrollLeft = parseFloat(
          contBoxW * selectedItem.offsetX -
            (1 * contBoxW * selectedItem.w) / (this.scaleValue / 100)
        ).toFixed(4);
        let scrollTop = parseFloat(
          contBoxH * selectedItem.offsetY -
            (3 * contBoxH * selectedItem.h) / (this.scaleValue / 100)
        ).toFixed(4);
        domScroll.scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;
        domScroll.scrollTop = scrollTop;
      }
    },
    loadingStart(info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose() {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 业务逻辑

    /**
     *  获取模板详情
     * */
    getTemplateDetailByID() {
      return new Promise((resolve, reject) => {
        let { id, userType } = this.$route.query;
        if (id) {
          const APIQuery =
            userType == 0
              ? ApiMethods.TemplateController.personVDetailByIDNom
              : ApiMethods.TemplateController.advanceVDetailByIDNom;
          APIQuery(id).then(result => {
            if (!result.success)
              return this.$message.error(result.description || this.$tip);

            let data = result.data;
            let context = data.context || {};

            // 合同名称
            this.contractInfo = {
              ...this.contractInfo,
              contractName: data.tplName,
              ifOrder: context.orderFlag, // 顺序签
              corpSuperUser: data.corpSuperUser || 0 // 是否是本人创建（本人创建，页面就不用显示审批）
            };

            // 显示合同
            let files = context.files;
            let contract = files.find(item => +item.tplFileType === 1); // 合同文件 1合同，2附件
            let fl = contract.storeFile;
            this.convertContractToInfo({
              fileName: contract.fileName,
              targetId: fl.targetId,
              fileType: fl.fileType,
              sign: fl.sign,
              ts: fl.ts,
              docHash: fl.docHash
            });

            // 显示附件
            let attatchFileNamesJson = files.filter(
              item => +item.tplFileType === 2
            ); // 附件 1合同，2附件
            attatchFileNamesJson = attatchFileNamesJson.map(item => {
              return {
                ...item,
                isTplFile: true // 是否模板创建人上传的附件【不能删除模板创建人上传的附件，可以删除自己上传的附件】
              };
            });
            this.attatchFileNamesJson = attatchFileNamesJson;

            // 签署方
            let signers = context.signers;
            this.signatoryJson = signers.map(item => {
              let userType = +item.userType;
              return {
                authLevel: item.authLevel,
                emailOrPhone: item.emailOrMobile,
                fix: item.fix, // 签署方是否固定
                signatoryFullName: item.name,
                orderNum: item.orderNum,
                signLevel: item.signLevel,
                signOwner: item.signerAbc,
                signatoryUserType: item.userType,
                childUserName: item.corpUser,
                signatoryIdentityCard: item.identityNo,
                signatoryMobile: +item.userType === 0 ? item.emailOrMobile : "",
                IDCard: userType === 0 ? item.identityNo : "",
                BusinessLicenseNo: userType === 0 ? "" : item.identityNo,
                handSign: userType === 0 ? 1 : 2,
                corpUser: false,
                chapteJson: null,
                // 新增集团账户 数组
                canSelectArray: [],
                canSelectArrayIndex: 0,
                ischange: 0,
                notRegister: true,
                disabled: "",
                openUserTab: false,
                isEncrypt: false
              };
            });

            console.log(this.signatoryJson, 777);

            // 显示组件
            let inputs = context.inputGroups[0].inputs;
            inputs = inputs.map((item, inx) => {
              let findSigners = signers.find(
                sub => sub.signerAbc === item.signerAbc
              ); // 找到该签章对应的签署人
              const inputItem = {
                ...item,
                qsInfo: findSigners ? findSigners.name : "", // 在签章上显示签署方的信息
                cindex: inx + "-" + new Date().getTime(),
                selected: false, // 填写变量页的辅助变量
                chapteFixed: this.chapteFixed, // 固定签章和组件位置
              };
              // 处理多选框类型变量接收值的方式
              if(inputItem.varType === this.flagType.flag.MULTIPLE) inputItem.value = []
              return inputItem
            });
            // 简单的排版优化根据页码做右侧变量定位
            this.chapteList = inputs.sort(function(a, b) {
              return a.page - b.page;
            });
            resolve();
          });
        } else {
          this.$message.warning("没有获取到模板ID");
          reject();
        }
      });
    },
    // 查询合同页数等信息
    convertContractToInfo(param) {
      this.loadingStart("正在加载合同信息");

      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();

          let tempFile = data.tempFile || {
            ts: param.ts,
            sign: param.sign,
            targetId: param.targetId,
            fileType: param.fileType
          };
          this.contractInfo.docHash = data.docHash;
          this.contractInfo.ts = tempFile.ts;
          this.contractInfo.sign = tempFile.sign;
          this.contractInfo.items = parseInt(data.items);
          this.contractInfo.contractId = tempFile.targetId;
          // this.contractInfo.contractName = param.contractName;
          this.currentInfo = { page: 1, url: "" };
          this.fileType = tempFile.fileType || 1;

          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },

    // 。。。。。。。。。。。合同跳转start。。。。。。。。。。。

    // 输入input合同跳页
    handleContractPageClick() {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed(page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage(val) {
      let dom = document.querySelectorAll(".page-con .list")[val - 1];
      if (dom) {
        document.querySelectorAll(".page-con")[0].scrollTop = dom.offsetTop;
      }
    },
    // 按页数获取合同
    getContractDetailByNum(num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }

      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          sign: this.contractInfo.sign,
          ts: this.contractInfo.ts,
          fileType: this.fileType,
          fix: "png",
          targetId: this.contractInfo.contractId,
          num: num - 1,
          docHash: this.contractInfo.docHash
        })
      };

      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    // 。。。。。。。。。。。合同跳转end。。。。。。。。。。。

    // 。。。。。。。。。。。。。。附件相关。。。。。。。。。。。。。。
    // 删除附件
    delAttatchFileNamesJson(attatch, index) {
      this.attatchFileNamesJson &&
        this.attatchFileNamesJson.length &&
        this.attatchFileNamesJson.splice(index, 1);
    },
    // 上传附件
    handleAttatchFileUpload(el) {
      if (this.attatchFileNamesJson.length >= 3) {
        this.$message.error("附件最多只能上传3个");
        return (el.target.value = "");
      }
      el = el.target;
      let file = el.files[0] || null;
      if (!file) return false;
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          console.log("上传附件：", data);
          el.value = "";

          let nameArr = file.name.split(".");

          this.attatchFileNamesJson.push({
            targetId: data.targetId,
            targetFix: "." + nameArr[nameArr.length - 1],
            origiName: nameArr.join(".")
          });
        })
        .catch(err => {
          this.loadingClose();
          el.value = "";
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    // 下一步
    nextStep() {
      this.$refs["varForm"].validate(valid => {
        if (valid) {
          // console.log('chapteList:', this.chapteList);
          this.step = "step2";
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 。。。。。。。。。。。。。。。。。。第二步骤逻辑 start。。。。。。。。。。。。。
    // 判断集团账户是否有审批流
    hasApprovalFlow() {
      // 。。。。。。。。。。。。。。。。审批。。。。。。。。。。。
      // 查询发起审批流
      let params = {};
      params.itemPage = 1;
      params.pageSize = 100;
      params.flowType = 0; // 流程类型0审批流程1用章流程
      ApiCorpMethods.CorpAuditContractController.pageFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.approvalFlowList = res.data;
            if (this.approvalFlowList.length > 0) {
              this.hasApplyApproval = true;
            } else {
              this.hasApplyApproval = false;
            }
          } else {
            this.hasApplyApproval = false;
            this.$message.error(res.description || "查询审批流程数据失败");
          }
        })
        .catch(error => {
          this.hasApplyApproval = false;
          this.$message.error(error.description || "查询审批流程数据失败");
        });
    },
    handleChangeApprovalFlow(val) {
      let params = {};
      params.flowId = val;
      ApiCorpMethods.CorpAuditContractController.preFlowInst(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              // flow
              if (data.partyList) {
                this.flows = data.partyList;
              }
              this.arrayCopior = [];
              if (data.copyToList) {
                (data.copyToList || []).forEach(i => {
                  i.hideRemove = true;
                  this.arrayCopior.push(i);
                });
              }
              if (data.orderFlag === 1) {
                this.flows.forEach((element, index) => {
                  if (this.flows.length - 1 !== index) {
                    element.hiddenArrow = true;
                  } else {
                    element.hiddenArrow = false;
                  }
                });
              } else {
                this.flows.forEach((element, index) => {
                  element.hiddenArrow = false;
                });
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },

    // 获取本公司部门
    getDepartmentList() {
      ApiCorpMethods.CorpCommonController.listGroup().then(res => {
        if (res.success) {
          this.department = res.data;
        }
      });
    },
    // 。。。。。。。。。。抄送。。。。。。。。。。。。。
    // 移除抄送人
    handleClickRemoveArrayCopior(index) {
      this.arrayCopior.splice(index, 1);
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyer(type) {
      this.auditAndCopyActive = type;
      if (type) {
        // 审批人
        this.auditAndCopyTitle = "添加审批人";
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
      }
      // 清空
      this.auditAndCopyModel.keyword = "";
      this.clickHandleAuditorOrCopyerSearch();
      this.visibleAuditAndCopy = true;
    },
    // 查询按钮
    clickHandleAuditorOrCopyerSearch() {
      if (this.auditAndCopyActive) {
        // 审批人
        this.auditAndCopyTitle = "添加审批人";
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
      }
      this.queryToolAuditAndCopy();
    },
    // 查询审批人 抄送人列表
    queryToolAuditAndCopy() {
      this.auditAndCopyModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (this.auditAndCopyModel.keyword) {
      this.auditAndCopyModel.targetId = this.auditAndCopyModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.auditAndCopyModel)
        .then(res => {
          this.auditAndCopyModel.loading = false;
          if (res.code === "0") {
            this.tableListAuditAndCopy = res.data;
            this.auditAndCopyModel.total = res.total;
            if (res.total === 0) {
              this.auditAndCopyModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListAuditAndCopy = [];
            this.auditAndCopyModel.total = 0;
            this.auditAndCopyModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.auditAndCopyModel.loading = false;
          this.tableListAuditAndCopy = [];
          this.auditAndCopyModel.total = 0;
          this.auditAndCopyModel.emptyText = res.description;
          this.$message.error(err.description);
        });
      // } else {
      //   this.auditAndCopyModel.loading = false;
      //   this.tableListAuditAndCopy = [];
      //   this.auditAndCopyModel.total = 0;
      //   this.auditAndCopyModel.emptyText = '请输入组织内部签署方名称或账号';
      // }
    },
    handleSizeChangeQueryToolAuditAndCopy(val) {
      this.auditAndCopyModel.itemPage = 1;
      this.auditAndCopyModel.pageSize = val;
      this.queryToolAuditAndCopy();
    },
    handleCurrentChangeQueryToolAuditAndCopy(val) {
      this.auditAndCopyModel.itemPage = val;
      this.queryToolAuditAndCopy();
    },
    // 添加审批人抄送人table row click event
    handleRowClickAuditAndCopy(row, event, column) {
      this.tableAuditAndCopySelectRow = row;
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyerSubmit() {
      if (this.auditAndCopyActive) {
        // 审批人
      } else {
        // 抄送人
        this.auditAndCopyTitle = "添加抄送人";
        if (!this.tableAuditAndCopySelectRow) {
          this.$message.error("请选择抄送人");
          return;
        } else {
          let isExist = false;
          for (let index = 0; index < this.arrayCopior.length; index++) {
            const element = this.arrayCopior[index];
            if (
              element.corpUserIdSec ===
              this.tableAuditAndCopySelectRow.corpUserIdSec
            ) {
              isExist = true;
            }
          }
          if (!isExist) {
            this.arrayCopior.push(
              JSON.parse(JSON.stringify(this.tableAuditAndCopySelectRow))
            );
            this.$message.success("抄送人添加成功");
          } else {
            this.$message.info("审批人已经存在,无需重复添加");
          }
        }
      }
    },

    // 。。。。。。。。。。。常用联系人 start。。。。。。。。。。。。
    // 获取最近联系人
    getTelList() {
      postTelFindByPagedEnterpriseList(this.telPageInfo)
        .then(data => {
          this.telList = data.data;
          this.telPageInfo.itemPage = data.pageNum;
          this.telPageInfo.pageSize = data.pageSize;
          this.telPageInfo.total = data.total;
        })
        .catch(err => {});
    },
    handleSizeChange(val) {
      this.telPageInfo.itemPage = 1;
      this.telPageInfo.pageSize = val;
      this.getTelList();
    },
    handleCurrentChange(val) {
      this.telPageInfo.itemPage = val;
      this.getTelList();
    },
    // 选择通讯录和我的组织里面的人 确认按钮事件
    handleClickSelectSignorOk() {
      if (this.activeTabSigner === "organization") {
        this.tableSignorSelectRow = undefined;
      }

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 复制以前的代码 怕报错
      /*********************************** */
      this.showTel = false;
      this.telPageInfo.accountNo = null;
      this.telPageInfo.name = null;
      this.telPageInfo.idNo = null;
      this.telPageInfo.itemPage = 1;
      // return openUserTab to false
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[
          this.selectIndex
        ].emailOrPhone = this.tableSignorSelectRowTargetID;
        // this.signatoryJson[this.selectIndex].openUserTab = false
      }

      /*********************************** */
      this.getUserInfoBySelectTargetId(
        this.tableSignorSelectRowTargetID,
        this.selectIndex
      );
    },
    // 根据用户从table选择的签署人查询信息
    getUserInfoBySelectTargetId(emailOrPhone, selectIndex) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }
      // 清空验证信息
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      }

      if (emailOrPhone) {
        this.tableSignorSelectRowTargetID = emailOrPhone;
      }
      if (!emailOrPhone || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let mobile = /^1[1-9]\d{9}$/;
      let email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      let targetId = this.tableSignorSelectRowTargetID;
      if (mobile.test(targetId) || email.test(targetId)) {
        postFindByEmailOrMphon({targetId}).then(data => {
          if (data.data) {
            this.fillSignorData(data.data);
          } else {
            this.fillSignorData([]);
          }
        });
      } else {
        this.fillSignorData([]);
      }
    },
    // 查询到结果后重新赋值
    fillSignorData(canSelectArray) {
      let signor = undefined;
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });
      if (canSelectArray.length === 0) {
        // 按照以前老版本改
        if (this.tableSignorSelectRow) {
          // 有值
          // businessLicense: "155454526254523"	证件号
          // enterpriseName: "15545"	签署方名称
          // mobileOrChild: "13896918730"	联系方式
          let targetId = this.tableSignorSelectRow.mobileOrChild;
          let isPhone = false;
          if (/^\d{11}$/.test(targetId)) {
            isPhone = true;
          }

          signor.signatoryFullName = this.tableSignorSelectRow.enterpriseName;
          signor.signatoryIdentityCard = this.tableSignorSelectRow.businessLicense;
          let userType = isPhone ? 0 : 1;

          signor.IDCard =
            userType === 0 ? this.tableSignorSelectRow.businessLicense : "";
          signor.BusinessLicenseNo =
            userType === 0 ? "" : this.tableSignorSelectRow.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";

          signor.signatoryUserType = userType;
          if (signor.signatoryUserType === 1) {
            signor.childUserName = targetId;
          } else {
            signor.signatoryMobile = targetId;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          signor.handSign = userType === 0 ? 1 : 2;
        } else {
          // 没有值
          // 下面这是清空的

          // signatoryFullName: 签署方名称, signatoryIdentityCard: 证件号, childUserName: 企业联系, signatoryMobile: 个人联系

          signor.signatoryFullName = "";
          signor.signatoryIdentityCard = "";
          signor.IDCard = "";
          signor.BusinessLicenseNo = "";
          signor.childUserName = "";
          signor.signatoryMobile = "";
          signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.handSign = 0;
        }
      } else {
        let current = this.$store.getters.currentAuthUser;
        let corpId = "";
        if (current) {
          corpId = current.corpId;
        }
        // 默认选择第一个
        signor.canSelectArrayIndex = 0;
        canSelectArray.forEach((element, index) => {
          if (element.corpId && element.corpId === corpId) {
            signor.canSelectArrayIndex = index;
            signor.corpUser = true;
          }
        });

        let v = canSelectArray[signor.canSelectArrayIndex];
        signor.signatoryFullName = v.name;
        signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
        signor.IDCard = v.userType === 0 ? v.identityCard : "";
        signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense;

        signor.childUserName = "";
        signor.signatoryMobile = "";

        signor.signatoryUserType = v.userType;
        if (signor.signatoryUserType === 1) {
          signor.childUserName = v.corpUser;
        } else {
          signor.signatoryMobile = signor.emailOrPhone;
        }
        signor.ischange = 1;
        signor.disabled = "disabled";
        if (signor.corpUser) {
          signor.handSign = 0;
        } else {
          signor.handSign = v.userType === 0 ? 1 : 2;
        }
      }
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.tableSignorSelectRow = undefined;
    },
    // 另外一边打开通讯录
    handleTelsClickOther: function(item, index) {
      item.openUserTab = true;
      this.selectIndex = index;
      this.getTelList();
      this.showTel = true;
      // 清空集团账户选择人列表
      this.myCorpModel.keyword = "";
      this.clickHandleMyCorpSearch();
      // return openUserTab to true
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[this.selectIndex].openUserTab = true;
      }
    },
    // 我的组织 选择签署人 点击事件
    handleRowClickMyCorp(row, event, column) {
      if (row) {
        this.tableSignorSelectRowTargetID = row.targetId;
      } else {
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 我的组织 查询签署人
    clickHandleMyCorpSearch() {
      const { userType } = this.$route.query;
      // 个人账户 不用查组织
      if (userType == 0) return false;
      this.queryToolMyCorp();
    },
    // 查询我的组织 签署人列表
    queryToolMyCorp() {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        .then(res => {
          this.myCorpModel.loading = false;
          if (res.code === "0") {
            this.tableListMyCorp = res.data;
            this.myCorpModel.total = res.total;
            if (res.total === 0) {
              this.myCorpModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListMyCorp = [];
            this.myCorpModel.total = 0;
            this.myCorpModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.myCorpModel.loading = false;
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(err.description);
        });
      // } else {
      //   this.myCorpModel.loading = false;
      //   this.tableListMyCorp = [];
      //   this.myCorpModel.total = 0;
      //   this.myCorpModel.emptyText = '请输入组织内部签署方名称或账号';
      // }
    },
    handleSizeChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      this.queryToolMyCorp();
    },
    handleCurrentChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = val;
      this.queryToolMyCorp();
    },
    // 通讯录点击选中一行
    handleTelRowClickSelectRow(row, event, column) {
      if (row) {
        this.tableSignorSelectRow = row;
        this.tableSignorSelectRowTargetID = row.mobileOrChild;
      } else {
        this.tableSignorSelectRow = undefined;
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 。。。。。。。。。。。常用联系人 end。。。。。。。。。。。。

    // 集团账户选择触发事件
    handleSelectCorpAccount(value, item) {
      if (value === "ManualInput") {
        // 新需求，新增手动输入
        item.name = "";
        item.identityNo = "";
        item.ischange = 0;
        item.disabled = "";
        item.userType = 0;
        item.corpUser = "";
        item.corpUserStatus = false;
        item.signatoryUserType = 1;
        item.ManualInput = true; // 标志启用手动输入
      } else {
        let v = item.canSelectArray[value];
        if (v.corpUser) {
          item.corpUser = true;
          item.handSign = 0;
        } else {
          item.corpUser = false;
          item.handSign = v.userType === 0 ? 1 : 2;
        }

        item.signatoryMobile = "";
        item.childUserName = "";
        item.signatoryUserType = v.userType;
        item.ischange = 1;
        item.disabled = "disabled";
        item.signatoryFullName = v.name;
        item.signatoryIdentityCard = v.businessLicense || v.identityCard;
        if (item.signatoryUserType === 1) {
          item.BusinessLicenseNo = v.businessLicense;
          item.IDCard = "";
          item.childUserName = v.corpUser;
        } else {
          item.IDCard = v.identityCard;
          item.BusinessLicenseNo = "";
          item.signatoryMobile = item.emailOrPhone;
        }
      }
    },
    // 处理用户类型选择
    handleSignUserType(signator) {
      console.log("signator", signator);
      signator.signatoryIdentityCard = "";
      signator.IDCard = "";
      signator.BusinessLicenseNo = "";
      signator.canSelectArray.forEach((elem, i) => {
        if (signator.signatoryUserType === elem.userType) {
          signator.canSelectArrayIndex = i;
        }
      });
      if (signator.signatoryUserType === 0) {
        signator.signatoryMobile = signator.childUserName;
        signator.childUserName = "";
        signator.handSign = 1;
        signator.ManualInput = false; // 重置手动输入
      } else {
        signator.childUserName = signator.signatoryMobile;
        signator.signatoryMobile = "";
        signator.handSign = 2;
      }
    },
    // 联系方式改变，或点击修改btn
    handleTargetIdChange(sign) {
      sign.disabled = "";
      sign.isEncrypt = false;
      sign.ischange = 0;
      sign.notRegister = true;
      sign.IDCard = "";
      sign.signatoryIdentityCard = "";
      if (!sign.canSelectArray || sign.canSelectArray.length === 0) {
        sign.signatoryFullName = "";
      }
    },
    // 是否需要人脸
    authLevelChange(item, i) {
      // console.log(this.signatoryJson[e]);
      // console.log(e,111111111)
      // if(!e) {
      //     this.authLevelShow = true
      // }
      this.$set(item, "checkedAuthLevel", true);
    },

    // 上一步
    preStep() {
      // 更新页面签章显示的签署人信息
      this.chapteList = this.chapteList.map(item => {
        let matchItem =
          this.signatoryJson.find(svv => item.signerAbc === svv.signOwner) ||
          {};
        return {
          ...item,
          qsInfo: matchItem.signatoryFullName || ""
        };
      });

      // 显示第一步
      this.step = "step1";
    },

    // 。。。。。。。。。。。。。。。。。。消费相关 start。。。。。。。。。。。。。。
    // 前往支付
    toPay() {
      this.payDisabled = true;
      const param = Object.assign(this.payInfoData.param, { pay: 1 });
      if (this.payInfoData.batch) {
        ApiCorpMethods.BatchContractController.batchCreate(param).then(res => {
          if (+res.code === 10806) {
            this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            this.payDisabled = false;
            return;
          }
          if (+res.code === 0) {
            this.$message.success("发起签署成功");
            if (this.isGroup) {
              this.$router.push({
                path:
                  "/corp/signInfo/applyList?match=-1&snapshotId=" +
                  this.payInfoData.snapshotId
              });
            } else {
              this.$router.push({
                path:
                  "/signInfo/applyList?match=-1&snapshotId=" +
                  this.payInfoData.snapshotId
              });
            }
            return;
          }
          this.$message.error(res.description || "支付失败");
          this.payDisabled = false;
        });
      } else {
        postCreateApply(param)
          .then(res => {
            if (+res.code === 0) {
              this.$message.success("发起签署成功");
              if (this.isGroup) {
                this.$router.push({
                  path:
                    "/corp/signInfo/applyList?match=-1&snapshotId=" +
                    this.payInfoData.snapshotId
                });
              } else {
                this.$router.push({
                  path:
                    "/signInfo/applyList?match=-1&snapshotId=" +
                    this.payInfoData.snapshotId
                });
              }
              return;
            }
            if (+res.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
              this.payDisabled = false;
            }
            this.$message.error(res.description || "支付失败");
            this.payDisabled = false;
          })
          .catch(err => {
            if (+err.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            }
            this.payDisabled = false;
          });
      }
    },
    // 。。。。。。。。。。。。。。。。。。消费相关 end。。。。。。。。。。。。。。.

    // 。。。。。。。。。。。。。。。。。。发布相关 start。。。。。。。。。。。

    // 发布前验证必要参数
    validForm() {
      // 验证模板名称
      this.$refs["contForm"].clearValidate();
      let validForm = true;
      let validFormListTab = this.$refs.contForm;
      validFormListTab.validate(() => {});
      try {
        const fields = validFormListTab.fields;
        if (fields) {
          fields.forEach(element => {
            if (element.prop !== "" && element.validateState === "error") {
              throw new Error("validFails");
            }
          });
        }
      } catch (error) {
        validForm = false;
      }

      // 验证批量签署方form表单列表
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }
      let validChildBatch = true;
      let contractBatchListTab = this.$refs.contractListTab;
      if (contractBatchListTab) {
        contractBatchListTab.forEach(t => {
          t.validate(() => {});
        });
        try {
          contractBatchListTab.forEach(t => {
            const fields = t.fields;
            if (fields) {
              fields.forEach(element => {
                if (element.prop !== "" && element.validateState === "error") {
                  throw new Error("validFails");
                }
              });
            }
          });
        } catch (error) {
          validChildBatch = false;
        }
      }

      if (!validForm || !validChildBatch) return false;

      // 集团账户 如果有审批流程 需要添加审批流程
      if (
        this.isGroup &&
        this.checkedBatch === false &&
        this.hasApplyApproval === true
      ) {
        if (
          this.approvalFlowList.length > 0 &&
          this.approvalFlowSelect === undefined
        ) {
          this.$message.error("请选择审批流程");
          return false;
        }
      }
      return true;
    },

    // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
    // 手动输入证件号后提交合同
    addContractById() {
      this.visibleCredit = false;

      this.signatoryJson.forEach(t => {
        if (this.entCreditJson[t.signatoryFullName]) {
          t.signatoryIdentityCard = this.entCreditJson[t.signatoryFullName];
        }
      });
      this.postSend();
    },
    // 取消合同发起或保存
    handleDelSendContract() {
      this.signatoryJson.forEach(t => {
        var entName = t.signatoryFullName;
        if (this.entNameArr.indexOf(entName) !== -1) {
          t.signatoryIdentityCard = "";
        }
      });
      this.entCreditArr = [];
      this.entCreditJson = {};
      this.entNameArr = [];
      this.userIdentityInfoArr = [];
      this.visibleCredit = false;
    },

    // 通过企业名称去查询企业的证件号
    queryEntIDByEntName(entNameArr) {
      this.entNameArr = entNameArr;
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryCreditCodeByEntName(entNameArr)
          .then(res => {
            this.loadingClose();
            if (res) {
              this.entCreditArr = [];
              this.entCreditJson = res;
              this.signatoryJson.forEach(t => {
                var entName = t.signatoryFullName;
                if (entNameArr.indexOf(entName) !== -1) {
                  if (res[entName]) {
                    t.signatoryIdentityCard = res[entName];
                  } else {
                    this.entCreditArr.push(entName);
                  }
                }
              });

              if (this.entCreditArr.length) {
                resolve({ sus: false }); // 显示签署方信息提示弹窗
              } else {
                resolve({ sus: true }); // 继续发起
              }
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log(
              "通过企业名称去查询企业的证件号： " + JSON.stringify(err)
            );
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },
    // 通过姓名身份证进行二要素验证
    twoElementsVerify(userInfoArr) {
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryUserValidateByNameIDnum(userInfoArr)
          .then(res => {
            this.loadingClose();
            if (res && res.length) {
              this.userIdentityInfoArr = res;
              resolve({ sus: false }); // 显示签署方信息提示弹窗
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log("身份证二要素验证： " + JSON.stringify(err));
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },
    // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《

    // 立即发布
    publishTpl() {
      // 参数验证
      if (!this.validForm()) return false;

      // 证件号合二为一 针对新用户

      let signatoryJsonCopy = JSON.parse(JSON.stringify(this.signatoryJson));
      signatoryJsonCopy.forEach(t => {
        if (!t.signatoryIdentityCard) {
          if (parseInt(t.signatoryUserType) === 1) {
            t.signatoryIdentityCard = t.BusinessLicenseNo;
          } else {
            t.signatoryIdentityCard = t.IDCard;
          }
        }
        if (!t.childUserName && !t.signatoryMobile) {
          if (parseInt(t.signatoryUserType) === 1) {
            t.childUserName = t.emailOrPhone;
          } else {
            t.signatoryMobile = t.emailOrPhone;
          }
        }
      });

      // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
      // 签署方是企业用户且没有证件号
      this.entCreditJson = {};
      this.entCreditArr = [];
      this.entNameArr = [];
      var queryCreditcodeParam = [];
      // 二要素验证变量
      this.userIdentityInfoArr = [];
      let userIdentityInfoParam = []; // 存放需要进行二要素的数组
      signatoryJsonCopy.forEach(t => {
        // 企业用户且没有证件号
        console.log("t", t);
        if (
          parseInt(t.signatoryUserType) === 1 &&
          t.signatoryFullName &&
          !t.identityNo
        ) {
          queryCreditcodeParam.push(t.signatoryFullName);
        }
        // 个人信息-姓名身份证二要素验证
        if (
          parseInt(t.signatoryUserType) === 0 &&
          t.signatoryFullName &&
          t.signatoryIdentityCard &&
          t.signatoryIdentityCard.indexOf("***") === -1
        ) {
          // 是个人且有姓名身份证号码，且身份证号码未加密（手动输入的）
          userIdentityInfoParam.push({
            name: t.signatoryFullName,
            identityNo: t.signatoryIdentityCard
          });
        }
      });
      if (
        (queryCreditcodeParam && queryCreditcodeParam.length) ||
        (userIdentityInfoParam && userIdentityInfoParam.length)
      ) {
        // 查询企业执照号，验证个人信息
        let arr = [];
        if (queryCreditcodeParam && queryCreditcodeParam.length) {
          // 查询企业执照号并将查询到的企业赋值
          arr.push(this.queryEntIDByEntName(queryCreditcodeParam));
        }
        if (userIdentityInfoParam && userIdentityInfoParam.length) {
          // 二要素验证，身份信息不正确的予以提示
          arr.push(this.twoElementsVerify(userIdentityInfoParam));
        }
        Promise.all(arr).then(res => {
          if (res && res.length) {
            for (let i = 0; i < res.length; i++) {
              let smt = res[i];
              if (smt && !smt.sus) {
                this.visibleCredit = true; // 显示签署方信息提示弹窗
                return false; // 中止后面的操作
              }
            }
            this.postSend(); // 信息无误
          }
        });
      } else {
        // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《
        this.postSend();
      }
    },

    // 发起完成之后回掉函数
    createdFinish(data, saveToDraftBox, batch, param) {
      const snapshotId = data.snapshotId || "";
      this.payInfoData = {
        batch: batch,
        param: param,
        recharge: data.recharge,
        snapshotId: snapshotId
      };
      this.loadingClose();

      if (!data.needPay || data.needPay === "false") {
        this.$message.success("发起签署成功");
        if (this.isGroup) {
          if (saveToDraftBox) {
            this.$router.push({
              path:
                "/corp/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            this.$router.push({
              path: "/corp/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            });
          }
        } else {
          if (saveToDraftBox) {
            this.$router.push({
              path: "/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            this.$router.push({
              path: "/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            });
          }
        }
      } else {
        // 改版了 去掉支付弹窗
        // const cashierUrl = decodeURIComponent(data.cashierUrl);
        // const _href = cashierUrl.split('returnURL=')[0] + 'returnURL=';
        // const returnUrl = cashierUrl.split('returnURL=')[1];
        // window.location.href = _href + encodeURIComponent(returnUrl + (returnUrl.indexOf('?') === -1 ? '?' : '&') + `snapshotId=${snapshotId}`);
        // return false;
        if (this.payInfoData.recharge) {
          this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
        } else {
          this.priseInfo.cashierUrl = data.cashierUrl || "";
          // this.priseInfo.money = data.money;
          this.priseInfo.point = data.point;
          this.priseVisibleDialog = true;
          var moneyData = data.moneyData || false;
          if (moneyData) {
            var moneryArr = [];
            // 签署次数
            if (moneyData.applySign && moneyData.applySign.timesPackage) {
              moneryArr.push(`签署${moneyData.applySign.timesPackage}次`);
            }
            // 银行卡4要数次数
            if (moneyData.bankFour && moneyData.bankFour.timesPackage) {
              moneryArr.push(`四要素${moneyData.bankFour.timesPackage}次`);
            }
            // 3要数次数
            if (moneyData.bankThree && moneyData.bankThree.timesPackage) {
              moneryArr.push(`三要素${moneyData.bankThree.timesPackage}次`);
            }
            // 人脸次数
            if (moneyData.face && moneyData.face.timesPackage) {
              moneryArr.push(`人脸${moneyData.face.timesPackage}次`);
            }
            if (moneryArr && moneryArr.length > 0) {
              this.priseInfo.mealInfo = moneryArr.join("；");
            }
          }
        }
      }
    },

    // 将合同变量填充并生成pdf
    fillContract(callback) {
      let { id: tplId, userType } = this.$route.query;
      const TplApi =
        userType == 0
          ? ApiMethods.TemplateController.advanceVPersonTplNom
          : ApiMethods.TemplateController.advanceVUseTplNom;
      TplApi({ tplId })
        .then(fileResult => {
          if (fileResult.success) {
            let d = fileResult.data;
            // 获取填写的变量信息
            let varList = this.getWidgets.chapteList.map(item => {
              const _new={
                inputId: item.inputId,
                value: item.value,
              }
              if(item.copy) _new.copy=item.copy
              if(item.varType === this.flagType.flag.MULTIPLE) _new.value = JSON.stringify(item.value)
              console.log('_new',_new);
              return _new;
            });
            let convertParam = {
              targetId: d.targetId,
              fileType: d.fileType,
              sign: d.sign,
              ts: d.ts,
              varList: JSON.stringify(varList),
              noConvert: 1 // 当为高级模板时才传，1不转换为图片，若要预览就传其他的
            };
            // 将变量填写到合同
            ApiMethods.FileOperController.convertInfoNoFile(convertParam)
              .then(convertResult => {
                //stype items docHash data
                if (!convertResult.success) {
                  this.loadingClose();
                  this.$alert(
                    convertResult.description || "操作失败",
                    "系统提示"
                  );
                } else {
                  let dd = convertResult.data;
                  // 填写成功后用发起targetId这份合同
                  callback &&
                    callback({ contractId: d.targetId, docHash: dd.docHash });
                }
              })
              .catch(err => {
                this.loadingClose();
                this.$message.error("提交失败");
              });
          } else {
            this.loadingClose();
            this.$alert(fileResult.description || "操作失败", "系统提示");
          }
        })
        .catch(err => {
          this.loadingClose();
          this.$message.error("提交失败");
        });
    },

    // 提交
    postSend() {
      let param = this.contractInfo;
      param.saveToDraftBox = false;

      if (!this.isGroup) {
        param.returnURL =
          configUrl().junziqianWebOp + "/signInfo/applyList?match=-1";
      }

      // 附件处理
      let attatchFileNamesJson = JSON.parse(
        JSON.stringify(this.attatchFileNamesJson)
      );
      attatchFileNamesJson = attatchFileNamesJson.map(item => {
        if (item.storeFile) {
          // 永久存储文件
          return {
            codeName: item.storeFile.targetId,
            origiName: item.fileName,
            file: item.storeFile
          };
        } else {
          // 临时存储文件
          return {
            targetId: item.targetId,
            targetFix: item.targetFix,
            origiName: item.origiName
          };
        }
      });
      param.attatchFileNamesJson = JSON.stringify(attatchFileNamesJson);

      // 签署方及其对应的签章信息
      let signatoryCopy = JSON.parse(JSON.stringify(this.signatoryJson));

      signatoryCopy = signatoryCopy.map(item => {
        // 归类属于当前签署人的签章
        let chapArr = this.chapteList.filter(
          sub => sub.signerAbc === item.signOwner
        );

        // 归类当前页的签章
        let obj = {};
        chapArr.map(svv => {
          if (!obj[svv.page]) obj[svv.page] = [];
          obj[svv.page].push({
            offsetX: svv.offsetX,
            offsetY: svv.offsetY,
            signOwner: svv.signerAbc,
            page: svv.page
          });
        });

        // 构造最终数据
        let chapteJson = [];
        Object.keys(obj).forEach(key => {
          chapteJson.push({
            chaptes: obj[key],
            page: +key
          });
        });

        return {
          ...item,
          chapteJson: chapteJson
        };
      });

      signatoryCopy.forEach(t => {
        if (!t.signatoryIdentityCard) {
          if (parseInt(t.signatoryUserType) === 1) {
            t.signatoryIdentityCard = t.BusinessLicenseNo;
          } else {
            t.signatoryIdentityCard = t.IDCard;
          }
        }
        if (!t.childUserName && !t.signatoryMobile) {
          if (parseInt(t.signatoryUserType) === 1) {
            t.childUserName = t.emailOrPhone;
          } else {
            t.signatoryMobile = t.emailOrPhone;
          }
        }

        //未注册高级模板个人使用手写
        if (t.corpUser) {
          t.handSign = 0;
        } else {
          t.handSign = parseInt(t.signatoryUserType) === 0 ? 1 : 2;
        }
      });
      param.signatoryJson = JSON.stringify(signatoryCopy);

      // 流程：
      // 1.用模板id调用useTpl接口获取WEB模版的文件操作签名
      // 2.调用convertInfo将变量信息填充到模板
      // 3.用当前填充好的模板发起合同
      this.loadingStart("正在提交...");
      this.fillContract(({ contractId, docHash }) => {
        param.contractId = contractId;
        param.docHash = docHash;
        console.log("param:", param);
        // 集团账户 添加审批流程
        if (this.isGroup) {
          // 抄送人
          if (this.checkedBatch === false) {
            param.flowId = this.approvalFlowSelect;
            // 添加审批人
            // 抄送人
            let carbonCopyJson = [];

            this.arrayCopior.forEach(element => {
              !element.hideRemove && carbonCopyJson.push(element.corpUserIdSec);
            });

            param.carbonCopyJson = JSON.stringify(carbonCopyJson);
            if (+param.flowId === 0) {
              delete param.flowId;
            }
            ApiCorpMethods.CorpApplyContractController.create(
              Object.assign(param, { pay: 1 })
            )
              .then(res => {
                if (res.code === "0") {
                  this.createdFinish(res.data, false);
                } else {
                  this.loadingClose();
                  if (+res.code === 10806) {
                    this.$message.error("积分/套餐不足，请联系公司管理员");
                  } else {
                    this.$message.error(
                      res.description || "签署失败，请刷新后再试"
                    );
                  }
                }
              })
              .catch(err => {
                this.loadingClose();
                console.log("签署：" + JSON.stringify(err));
                this.$message.error(
                  err.description || "签署失败，请刷新后再试"
                );
              });
          }
        } else {
          postCreateApply(param)
            .then(({ data }) => {
              this.createdFinish(data, false, false, param);
            })
            .catch(err => {
              this.loadingClose();
              this.$message.error(err.description || "签署失败，请刷新后再试");
            });
        }
      });
    }
    // 。。。。。。。。。。。。。。。。。。发布相关 end。。。。。。。。。。。

    // 。。。。。。。。。。。。。。。。。。第二步骤逻辑 end。。。。。。。。。。。。。
  },
  layout: "fullpage",
  head: { title: "填写模板变量" },
  name: "writeVariables"
};
</script>

<style lang="less" scoped>
@import (less) "../../assets/style/icon.css";

.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.to-create {
  margin: -20px;
}

@mg: 0.2rem; // 左右side给中间合同流的间距

.aside-left {
  /*padding-top: .20rem;*/
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 3;
  margin-right: @mg;

  .cred {
    color: #ec1c1c;
  }

  .list.active img {
    border-color: #ec1c1c;
  }

  .list.active span {
    background-color: #ec1c1c;
  }

  .list {
    position: relative;
    margin: 0 0.3rem 0.2rem 0.3rem;
    cursor: pointer;

    span {
      position: absolute;
      bottom: 0.1rem;
      right: 0;
      display: block;
      /*width: 20px;*/
      /*height: 20px;*/
      width: 0.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.06rem 0px 0px 0px;
      color: #fff;
      background-color: #e3e3e3;
      text-align: center;
    }

    img {
      width: 100%;
      /*max-height: 230px !important;*/
      max-height: 3rem !important;
      box-sizing: border-box;
      margin-bottom: 0.1rem;
      border: 0.02rem solid #e3e3e3;
    }
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    padding: 0 0.3rem 0 0.3rem;
    height: 60px;
    line-height: 60px;
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 60px;
    box-sizing: border-box;
    padding-top: 0.2rem;
    border-top: 1px solid #f2f2f2;
  }

  // 跳转页面
  .go-Page {
    // height:60px;
    // line-height:60px;
    padding: 0.3rem 0;
    width: 100%;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 5;
    background-color: #ffffff;

    > div {
      display: inline-block;

      > div {
        display: flex;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        line-height: 28px;
      }
    }

    .bd {
      height: 100%;
      box-sizing: border-box;
      border: 1px solid rgba(183, 183, 183, 1);
      border-style: solid none solid solid;
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      padding-right: 0.05rem;
      border-radius: 0.04rem 0 0 0.04rem;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      box-sizing: border-box;
      width: 0.6rem;
      border-radius: 0px 0.04rem 0.04rem 0.04rem;
      display: block;
      background: #999999;
      border: 1px solid #999999;
      color: rgba(255, 255, 255, 1);
      font-family: PingFang SC;
    }

    /deep/ .el-input {
      /*width: 75px;*/
      width: 1.2rem;
      height: 100%;
    }

    /deep/ .el-input__inner {
      font-size: 0.14rem;
      border: none;
      padding: 0 0 0 0.05rem;
      height: 100%;
      line-height: inherit;
    }
  }
}

.main-content {
  flex: 1;
  position: relative;
  /*display: table-cell;*/
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;
  z-index: 2;

  .accessory-box {
    position: absolute;
    bottom: -106px;
    width: 100%;
    pointer-events: none;
    z-index: 8;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*flex-wrap: wrap;*/
      /*align-items: center;*/
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      li {
        /*flex: none;*/
        /*display: table-cell;*/
        /*width: 100%;*/
      }

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }

        /*input {*/
        /*  position: absolute;*/
        /*  width: 300px;*/
        /*  height: 300px;*/
        /*  top: -18px;*/
        /*  left: -73px;*/
        /*  cursor: pointer;*/
        /*  opacity: 0;*/
        /*}*/

        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

.aside-right {
  color: #290202;
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  z-index: 3;
  margin-left: @mg;
  padding-bottom: 1.49rem;

  .top {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    padding-top: 0.81rem;
    padding-bottom: 0.1rem;
    position: relative;
    text-align: left;

    .t-title {
      position: absolute;
      top: 0.29rem;
      padding: 0 0.2rem;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      font-size: 0.16rem;
      font-family: PingFang SC;
      font-weight: bold;
      color: #290202;
      text-align: left;
    }

    .box {
      height: 100%;
      width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      /*padding-left: .1rem;*/
      padding-right: 0.2rem;
      box-sizing: border-box;
    }
  }

  .bb-box {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1.49rem;
    background: #ffffff;
    box-shadow: 0rem -0.03rem 0.12rem rgba(0, 0, 0, 0.06);
    opacity: 1;
    padding: 0.32rem 0.28rem;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .variablesForm {
    /deep/ .el-form-item {
      margin-bottom: 0.25rem;

      .el-form-item__label {
        line-height: 30px;
        padding: 0 0.12rem 0 0;
        font-size: 14px;
      }

      .el-form-item__content {
        line-height: 30px;
      }

      .el-input__inner {
        height: 30px;
        line-height: 30px;
        padding: 0 0.1rem;
        font-size: 14px;
      }
    }

    /deep/ .el-textarea__inner {
      padding: 0.05rem 0.1rem;
      font-size: 14px;

      &:focus {
        border-color: #ec1c1c;
        outline: 0;
      }
    }

    /deep/ .el-date-editor {
      .el-input__icon {
        line-height: 30px;
      }

      .el-input__inner {
        padding-left: 0.4rem;
      }
    }

    /deep/ .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }

    /deep/ .el-form-item__error {
      padding-top: 0.02rem;
    }

    // 选择样式
    .outstanding {
      /deep/ .el-input__inner,
      /deep/ .el-textarea__inner {
        border: 1px solid #ec1c1c;
      }
      /*日期*/
      /deep/ .el-date-editor {
        .el-input__inner {
          border: 1px solid #ec1c1c;
        }
      }
    }
    .var-name-sty{
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}

.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}

.danger-btn {
  height: 35px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  background-color: #ff0000;
  font-size: 14px;
}

.default-btn {
  flex: auto;
  height: 35px;
  line-height: 35px;
  padding: 0;
  margin: 0;
  color: rgba(41, 2, 2, 0.45);
  border: 1px solid rgba(220, 220, 220, 0.69);
  font-size: 14px;
  margin-left: 0.18rem;
  width: 1.28rem;

  &:first-child {
    margin-left: 0;
  }
}

.f-btn {
  width: 120px;
  line-height: 35px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  padding: 0;
  box-sizing: border-box;
}

.nobg-btn {
  background: transparent;
  border: 1px solid rgba(220, 220, 220, 1);
  color: rgba(41, 2, 2, 0.45);
}

/*第二步*/
.s-content {
}

.cont-form {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  width: 100%;
  box-sizing: border-box;

  .amend-tab__form {
    display: inline-block;
    position: absolute;
    width: 30px;
    right: 0;
  }

  .el-radio.is-bordered.is-checked {
    border-color: #ec1c1c;
    color: #333333;
  }

  .checkbox {
    width: 100%;
    height: 80px;
    padding-top: 22px;

    &.end-time {
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      padding: 10px;
      border: 1px solid #dcdfe6;
    }

    p.small {
      padding-left: 0px;
    }

    p.title {
      font-size: 12px;
      color: #666666 !important;
      font-weight: 600;

      i {
        box-sizing: border-box;
        color: #ec1c1c;
      }
    }

    p {
      color: #333333 !important;
      display: inline-block;
    }
  }

  div.h4,
  h4 {
    padding-top: 10px;
    line-height: 36px;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(41, 2, 2, 1);
    /*padding-left:15px;*/

    > i {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: rgba(41, 2, 2, 1);
      opacity: 1;
      border-radius: 100px;
      margin-right: 10px;
      vertical-align: middle;
    }

    .more-set {
      line-height: 32px;
      font-size: 14px;
      margin-right: 20px;
      cursor: pointer;

      i {
        font-size: 26px;
        vertical-align: middle;
      }

      &.down i {
        animation: keyRotateToToDown 0.3s;
        transform: rotate(180deg);
      }

      &.up i {
        animation: keyRotateToUp 0.3s;
        transform: rotate(0deg);
      }

      &.down-noani i {
        transform: rotate(180deg);
      }

      &.up-noani i {
        transform: rotate(0deg);
      }
    }
  }

  /*20200526重置样式*/

  /deep/ .el-input__inner {
    height: 35px;
    line-height: 35px;
    padding-left: 10px;
  }

  .f-top {
    background-color: #ffffff;
    margin-bottom: 20px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-row {
      padding: 20px 30px 20px 20px;
    }
  }

  .f-center {
    .f-top();

    div.h4 {
      flex-wrap: nowrap;

      .el-checkbox__label {
        /*color: #000000;*/
        font-weight: normal;

        b {
          font-weight: normal;
          /*color: #000000;*/
        }
      }

      small {
        color: rgba(0, 0, 0, 0.45);
        margin-left: 5px;
      }

      .more-set {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .wp {
      flex: auto;
      margin-left: 40px;
    }

    .radio {
      padding: 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
    }

    li .el-row {
      padding: 0;
    }
  }

  .f-center2 {
    .f-top();
  }

  .f-bottom {
    .f-top();
  }

  .bow {
    padding: 20px;
  }

  .sign-item {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    position: relative;

    > div {
      /*flex: none;*/

      &:last-child {
        flex: auto;
        text-align: right;
      }
    }
  }

  .c-btn {
    min-width: 82px;
    line-height: 25px;
    padding: 0;
    font-size: 12px;
    text-align: center;
    border: 1px solid rgba(236, 28, 28, 1);
    border-radius: 2px;
    color: #ec1c1c;

    &:hover {
      background-color: gba(236, 28, 28, 1);
      color: #ffffff;
    }
  }

  .y-btn {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    border: none;
    padding: 0;
    color: #ec1c1c;
    background: transparent !important;

    &:hover {
      opacity: 0.5;
    }
  }

  .list-box {
    padding-top: 25px;
    padding-bottom: 22px;

    .contract-lit__tab {
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    .t-row {
      font-size: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #f8f8f8;
      line-height: 50px;
      color: rgba(41, 2, 2, 1);
      flex-wrap: nowrap;
      > .ov {
        flex: none;
        .font-elips();
      }
    }

    .index {
      font-size: 12px;
      display: inline-block;
      width: 18px;
      height: 18px;
      line-height: 18px;
      border: 1px solid #b7b7b7;
      border-radius: 50%;
      opacity: 1;
      margin-left: 15px;
      /*margin-right: 10px;*/
      text-align: center;
      color: rgba(183, 183, 183, 1);
    }

    .fb {
      flex: 1 !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(41, 2, 2, 0.45);
      padding-right: 15px;
      line-height: 50px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .icon-gg,
    .icon-nogg {
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .s-er /deep/ .el-form-item__error {
    top: 74%;
    left: 20px;
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ec1c1c;
}

/deep/ .el-checkbox__inner {
  width: 15px;
  height: 15px;
}

/*抄送样式*/
.audit-box i {
  width: 48px;
  height: 48px;
}
.audit-box i.size17 {
  width: 10px;
  height: 10px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.tel-search {
  margin-top: 10px;
  margin-bottom: 10px;
}

/deep/ .tel-box {
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/advancedVersion/writeVariablesView.vue